import { useTranslation } from 'react-i18next';

import { I18NextNS } from 'src/models/Language.model';
import { EyesPosition } from 'src/models/Session.model';

import warningIcon from '../../../assets/icons/warning.svg';
import StatusCardTemplate from './StatusCardTemplate';

type BadQualityStatusCardProps = {
  eye: EyesPosition;
};
export default function BadQualityStatusCard({
  eye,
}: BadQualityStatusCardProps) {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'newExam.analyzingModal.statusCards.badQuality',
  });

  return (
    <StatusCardTemplate
      icon={<img src={warningIcon} alt="Warning" />}
      iconBackgroundColor="warning-100"
      primaryText={t('primary')}
      secondaryText={t('secondary', { eye: t(eye) })}
      dataTest={`status-bad-quality-${String(eye).toLowerCase()}`}
    />
  );
}
